var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.extraClasses,attrs:{"type":"button","data-toggle":_vm.dataToggle,"data-target":_vm.dataTarget,"disabled":_vm.disabled},on:{"click":_vm.onBtnClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }